let instanceRef = null;

export const setMsalInstance = (instance) => {
  instanceRef = instance;
};

export const getMsalInstance = () => instanceRef;
